module.exports = __webpack_public_path__ + "img/title-ornament.ac1f3ae0.svg";